import { createSignal, onMount, Show, Signal } from 'solid-js'
import { ReportInfoCard } from 'st-app/api'
import STButton, { ButtonType } from '../st-button/st-button'
import STInput from '../st-input/st-input'
import './copy-wizard.css'
import { reportBrowser as api }  from 'st-app/api'
import { requireReportBrowser } from './report-browser-context'
import { toast } from 'common'

interface CopyWizardProps {
    report: ReportInfoCard
    isCopying: Signal<boolean>
}

export default function CopyWizard(props: CopyWizardProps) {
    const reportBrowser = requireReportBrowser()

    const defaultName = props.report.name ? `${props.report.name} - Copy` : ''
    const defaultNumber = props.report.number ? `${props.report.number}C` : ''

    const [_, setIsCopying] = props.isCopying

    const nameSignal = createSignal(defaultName)
    const [name] = nameSignal

    const numberSignal = createSignal(defaultNumber)
    const [number] = numberSignal

    const [isLoading, setIsLoading] = createSignal(false)

    const copy = async () => {
        setIsLoading(true)
        try {
            const newReport = await api.CopyReport(props.report.reportGU ?? '', number(), name())
            reportBrowser.addReport(newReport)
            setIsCopying(false)
            reportBrowser.setSearchStr('')
            reportBrowser.setSelectedGroup(reportBrowser.state.groups.find(g => g.description === 'My Reports')!)
            reportBrowser.expandReport(newReport)
        } catch (e) {
            if (typeof e === 'string') {
                toast.notify('error', e)
            } else {
                toast.notify('error', 'An error occurred while copying the report.')
            }
        }
        setIsLoading(false)
    }

    return (
        <div class="copy-wizard">
            <div class="report-info-container">
                <div style="flex-basis: 50%;">
                    <span>Report Number</span>
                    <STInput value={numberSignal} selected focused></STInput>
                </div>
                <div style="flex-basis: 50%;">
                    <span>Report Name</span>
                    <STInput value={nameSignal}></STInput>
                </div>
            </div>
            <STButton loading={isLoading()} type="primary" onClick={copy}>
                Create
            </STButton>
        </div>
    )
}